
import React, { useState, useEffect } from 'react'
import { DivTag } from '../../../Components/Tags/Tags'
import Header from '../../../Components/Header'
import Seo from '../../../Components/SeoComponent/Seo'
import { HeadTag, InputField } from '../../../Components/Tags/Tags'
import { showSuccessToast, showErrorToast } from '../../../utils/toastUtils'
import GaugeChart from 'react-gauge-chart'
import { GetCrifPDFService,downloadEquifaxPDF } from '../../../Services/CreditScorePDF/CreditScorePdf'
import Loader from '../../../Loader'
import { fetchProfile } from '../../../Services/profile/profileservice'

const CrifPdfUrl = () => {
  const [cusName, setCusName] = useState('')
  const [mobile, setMobile] = useState('')
  const [errors, setErrors] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [creditScore, setCreditScore] = useState(0)
  const [profileData, setProfileData] = useState([])
  const [showLoader, setShowLoader] = useState(false)
  const [pdfUrl, setPdfUrl] = useState('') // Store PDF URL from response

  const maxScore = 900

  const validateForm = () => {
    const newErrors = {}

    if (!cusName) {
      newErrors.cusName = 'Customer name is required.'
    }

    if (mobile === "") {
      newErrors.mobile = 'Mobile number is required.'
    } else if (!/^[6-9]\d{9}$/.test(mobile)) {
      newErrors.mobile = 'Enter a valid 10-digit mobile number.'
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handlesubmit = async () => {
    try {
      const isValid = validateForm()
      if (!isValid) {
        setPdfUrl('')
        setCreditScore(0)
        showErrorToast('Please correct the form errors.')
        return
      }
      
      setShowLoader(true)
      await addCrifPdf()
      
      setTimeout(() => {
        setShowLoader(false)
      }, 2000)
    } catch (error) {
      console.error('Error submitting data:', error)
      showErrorToast('Validate the Required Field')
      setShowLoader(false)
    }
  }

  // View PDF in new tab
  const handleViewPDF = () => {

    if (pdfUrl) {
      window.open(pdfUrl, '_blank', 'noopener,noreferrer')
    } else {
      showErrorToast('No PDF URL available')
    }
  }



  // Update handleDownloadPDF
const handleDownloadPDF = async () => {
 // console.log("url Down",pdfUrl);
  if (!pdfUrl) {
    showErrorToast('No PDF URL available')
    return
  }

  try {
    setIsLoading(true)
    
    const blob = await downloadEquifaxPDF(pdfUrl)
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = `Crif_Report_${Date.now()}.pdf`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
    
    showSuccessToast('PDF downloaded successfully')
  } catch (error) {
    console.error('Error downloading PDF:', error)
    showErrorToast('Failed to download PDF')
  } finally {
    setIsLoading(false)
  }
}




  async function addCrifPdf() {
    try {
      setShowLoader(true)
      setIsLoading(true)
      
      const payload = {
        api_id: profileData?.user_id,
        api_key: profileData?.api_key,
        token_id: profileData?.token_id,
        name: cusName,
        mobile: mobile,
        consent: "Y"
      }

      const response = await GetCrifPDFService(payload)

     // console.log("res crif",response);
      const statusCode =
  response?.data?.status?.code ||
  response?.status?.code ||
  response?.status

  const message =
  response?.data?.status?.message ||
  response?.data?.message ||
  response?.status?.message ||
  response?.message

     if (statusCode === 403) {
  showErrorToast("Invalid or deactivated API key.")
  return
}

if (statusCode === 422) {
  if (message === "Insufficient balance in api user wallet.") {
    showErrorToast("Insufficient balance in api user wallet.")
  } else if (message === "User not authorized to access this service.") {
    showErrorToast("User not authorized to access this service.")
  } else {
    showErrorToast(message || "Validation error")
  }
  return
}

 if (statusCode === 200) {
  // Extract PDF URL and credit score from response
  const reportUrl = response?.data?.report_url || response?.data?.data?.report_url
  const score = response?.data?.credit_score || 0 // Handle null score
  console.log("url",reportUrl);
  setPdfUrl(reportUrl)
  setCreditScore(score)

  // Clear form
  setCusName('')
  setMobile('')

  showSuccessToast(response?.status?.message || response?.message || "Report generated successfully.")
}
 else {
        setPdfUrl('')
        showErrorToast(
          response?.data?.message ||
          response?.message ||
          "Something went wrong."
        )
      }
    } catch (error) {
      console.error("Error in crif PDF:", error)
      setPdfUrl('')
      showErrorToast("Something went wrong.")
    } finally {
      setShowLoader(false)
      setIsLoading(false)
    }
  }

  useEffect(() => {
    async function fetchProfileData() {
      try {
        const response = await fetchProfile()
        setProfileData(response.data)
      } catch (error) {
        console.error('Error fetching profile data', error)
      }
    }
    fetchProfileData()
  }, [])

  return (
    <>
      <Seo />
      {showLoader && <Loader />}

      <Header heading='Crif PDF Report' />


<div className="flex justify-center items-start gap-2">
  <DivTag className="w-1/5">
    <HeadTag className="text-md font-serif">
      Name<strong className="text-red-700">*</strong>
    </HeadTag>
    <input
      type="text"
      value={cusName}
      className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600 w-full"
      placeholder="Enter First Name"
      onChange={(e) => setCusName(e.target.value)}
    />
    {errors.cusName && (
      <p className="text-red-600 text-sm font-mono">
        {errors.cusName}
      </p>
    )}
  </DivTag>

  <DivTag className="w-1/5">
    <HeadTag className="text-md font-serif">
      Mobile<strong className="text-red-700">*</strong>
    </HeadTag>
    <InputField
      type="text"
      placeholder="Enter Mobile"
      className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600 w-full"
      value={mobile}
      onChange={(e) => setMobile(e.target.value)}
    />
    {errors.mobile && (
      <p className="text-red-600 text-sm font-mono mt-1">
        {errors.mobile}
      </p>
    )}
  </DivTag>
</div>


      <div className="flex justify-center">
        <button
          className={`rounded-md p-1 bg-blue-700 text-white mt-8 mb-3 h-8 px-3 ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
          onClick={handlesubmit}
          disabled={isLoading}
        >
          {isLoading ? 'Submitting...' : 'Get Score'}
        </button>
      </div>

      {pdfUrl && (  // Remove creditScore > 0 condition
  <div className="flex flex-col p-4 bg-white shadow-inner md:mt-1 shadow-blue-600 rounded-md">
    <h2 className="text-xl md:text-xl font-semibold text-center">Your Crif Credit Report</h2>

    <div className="flex flex-col md:flex-row justify-center md:justify-center gap-4 md:gap-8 md:mt-2 mt-3 relative">
      
      {creditScore > 0 ? (  // Show gauge only if score exists
        <div className="w-full md:w-[400px] relative md:mt-10">
          <span className="text-red-500 md:font-bold absolute md:top-[20px] md:left-10 md:mt-16 -rotate-70 top-[60px] left-5">Poor</span>
          <span className="text-yellow-400 md:font-bold absolute md:left-[104px] md:mt-1 -rotate-26 left-[69px] top-[-7px]">Average</span>
          <span className="text-orange-600 md:font-bold absolute md:left-60 md:mt-0 md:rotate-20 left-[12rem] mt-[-9px] rotate-20">Good</span>
          <span className="text-green-800 md:font-bold absolute md:top-[20px] md:ml-[19.5rem] md:mt-16 rotate-70 ml-[16rem] mt-[3.5rem]">Excellent</span>

          <GaugeChart
            id="gauge-chart1"
            nrOfLevels={3}
            percent={creditScore / maxScore}
            needleColor={"#00008b"}
            textColor={"transparent"}
            needleBaseColor={"red"}
            arcsLength={[0.3, 0.3, 0.3, 0.3]}
            colors={['#cc0000', '#e6e600', '#cc6600', '#009900']}
          />
          <p className="text-black font-bold text-xl md:text-2xl absolute bottom-12 md:bottom-[5.5rem] left-1/2 transform -translate-x-1/2">
            {creditScore}
          </p>
        </div>
      ) : (
        <div className="text-center text-gray-600 text-lg">
          Report generated successfully. Credit score not available.
        </div>
      )}

      <div className="flex flex-col items-center md:items-start">
        <div className="flex space-x-2 mt-4">
          <button
            onClick={handleViewPDF}
            className="bg-blue-600 text-white text-sm md:text-base rounded-md px-4 py-2 hover:bg-blue-700"
          >
            View PDF
          </button>
          
          <button
            className="bg-green-600 text-white text-sm md:text-base rounded-md px-4 py-2 hover:bg-green-700"
            onClick={handleDownloadPDF}
            disabled={isLoading}
          >
            {isLoading ? "Downloading..." : "Download PDF"}
          </button>
        </div>
      </div>
    </div>
  </div>
)}

    </>
  )
}

export default CrifPdfUrl
